import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/ui/ScrollToTop";

import CookieBanner from "./components/ui/CookieBanner";
import FloatingSocialIcons from "./components/ui/FloatingSocialIcons";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
        <CookieBanner />
        <FloatingSocialIcons />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;



